import type { AccountHolderLoginResponse } from '../../../declarations/auth-api';
import makeCall from '../../../helpers/caller';
import { getURLParam } from '../../../helpers/helpers';

// ------------------------------------
// Constants
// ------------------------------------

export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAILED = 'VERIFY_FAILED';

// ------------------------------------

// keep this in sync with auth-api
export interface ValidateEmailResult extends AccountHolderLoginResponse {
  status: 'ok' | 'already-verified';
  lotameId?: string | null;
  hasOffersId?: string | null;
  ppToken: string; // required by pp-gateway app
  emailValidated: boolean; // required by pp-gateway app
}

export const verifySuccess = (verificationResponse: ValidateEmailResult) => ({
  type: VERIFY_SUCCESS,
  verificationResponse,
});

export const verifyFailed = () => ({
  type: VERIFY_FAILED,
});

export const submit = () => (dispatch, _getState) =>
  makeCall<ValidateEmailResult>({
    call: {
      job: 'validateEmail',
      section: 'auth',
    },
    payload: {
      token: getURLParam('token', window.location.href),
    },
  })
    .then((verificationResponse) => {
      dispatch(verifySuccess(verificationResponse));
    })
    .catch((_error) => {
      dispatch(verifyFailed());
    });

const initialState = {
  verificationFailed: false,
  verified: false,
};

const emailVerification = (state = initialState, action) => {
  if (action.type === 'VERIFY_SUCCESS') {
    const a = action as ReturnType<typeof verifySuccess>;
    return {
      ...state,
      verificationResponse: a.verificationResponse,
      verified: true,
    };
  }
  if (action.type === 'VERIFY_FAILED') {
    return {
      ...state,
      verificationFailed: true,
      verified: false,
    };
  }
  return state;
};

export default emailVerification;
